import Vue from "vue"

import App from "./App.vue"
import router from "./router"
import vuetify from "./plugins/vuetify"
import store from "./store"
import VueHtmlToPaper from "vue-html-to-paper"
import VueSwal from "vue-swal"
import "viewerjs/dist/viewer.css"
import Vuer from "v-viewer"
import * as VueGoogleMaps from "vue2-google-maps"
import VueClipboard from "vue-clipboard2"
import VueLazyload from "vue-lazyload"
import VuePlaceAutocomplete from "vue-place-autocomplete"
import BackToTop from "vue-backtotop"
import VueCoreVideoPlayer from "vue-core-video-player"
import VueSignaturePad from "vue-signature-pad"

Vue.use(VueSignaturePad)

let key_ggmap
let key_arr = [
    "AIzaSyDQCv8fVIqYNpcymWgQW2oVmX6fhbuKzZ4", //svc-cri@acacia-it.co.th --
    "AIzaSyCKptaHRrVM0kq5toOx-IOO-tQ1OdKtlM4", //svc-ska@acacia-it.co.th --
    "AIzaSyDRHS_1Ys_lCtgFIWWdMe43BRH04xS36wU", //svc-cnx@acacia-it.co.th --
    "AIzaSyBjb5bF60hOBtSE0EifuxdiIsmDRpIHXxE",
]
let key_arr2 = [
    "AIzaSyBAofWNn0gamZhhKLXecRH1s02MpCEQB_A", //svc-cho@acacia-it.co.th --
    "AIzaSyB1uVyu8pW4Bn_a5u8lVIM4KjY0EADePog", //svc-ray@acacia-it.co.th
]

if (localStorage.team_name == undefined) {
    key_ggmap = key_arr[Math.floor(Math.random() * key_arr.length)]
} else {
    if (localStorage.team_name == "ONSITE") {
        if (localStorage.role_name == "WFH") {
            key_ggmap = "AIzaSyDQCv8fVIqYNpcymWgQW2oVmX6fhbuKzZ4"
        } else if (
            localStorage.role_name == "TL" ||
            localStorage.role_name == "HOST"
        ) {
            key_ggmap = "AIzaSyCKptaHRrVM0kq5toOx-IOO-tQ1OdKtlM4"
        } else {
            key_ggmap = key_arr2[Math.floor(Math.random() * key_arr2.length)]
        }
    } else if (localStorage.team_name == "NONHP") {
        key_ggmap = "AIzaSyDRHS_1Ys_lCtgFIWWdMe43BRH04xS36wU"
    } else {
        key_ggmap = "AIzaSyBjb5bF60hOBtSE0EifuxdiIsmDRpIHXxE"
    }
}

// console.log(key_ggmap)

require("./assets/style/main.css")
Vue.use(VueCoreVideoPlayer)

Vue.config.productionTip = false
import { VueEditor } from "vue2-editor"
const options = {
    name: "_blank",
    specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
    styles: [
        "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
        "https://unpkg.com/kidlat-css/css/kidlat.css",
    ],
}
Vue.use(VueLazyload)
Vue.use(BackToTop)
Vue.use(Vuer, {
    name: "vuer",
})
Vue.component("VueEditor", VueEditor)
VueClipboard.config.autoSetContainer = true // add this line
Vue.use(VueClipboard)
Vue.use(VueGoogleMaps, {
    load: {
        key: key_ggmap,
        libraries: "places",
    },
    installComponents: true,
})
Vue.use(VuePlaceAutocomplete)

Vue.use(VueHtmlToPaper, options)
Vue.use(VueSwal)

import VueQRCodeComponent from "vue-qrcode-component"
Vue.component("qr-code", VueQRCodeComponent)

import ThailandAutoComplete from "vue-thailand-address-autocomplete"
Vue.component("ThailandAutoComplete", ThailandAutoComplete)

new Vue({
    vuetify,
    render: (h) => h(App),
    store,
    router,
}).$mount("#app")